export const downloadCSV = (data, filename) => {
    if (!data || !data.length) return;

    // Extract headers (keys of first object)
    const headers = Object.keys(data[0]);

    // Convert to CSV string, handling quotes and commas
    const csvContent = [
        headers.join(','), // Header row
        ...data.map(row => headers.map(header => {
            const value = row[header];
            // Format value for CSV (escape quotes)
            if (value === null || value === undefined) return '';
            const stringValue = String(value);
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return stringValue;
        }).join(','))
    ].join('\n');

    // Create Blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
